import React from 'react';
import { descend, compose, path, sortWith } from 'ramda';
import { dateValue } from 'lib/dateDisplay';
import { isCompletedMSNQ } from 'neuro-calculation-commons';
import { isCompletedFSMC } from './calculateFSMC';
import MSNQInfo from './components/MSNQInfo';
import FSMCInfo from './components/FSMCInfo';

const sorter = sortWith([descend(compose(dateValue, path(['createDate'])))]);

const getLatestStatusDoc = documents => {
  return sorter(documents.filter(d => d.documentType === 'status'))[0];
};

export const getScoreSummaryDialog = (doc, type, documents) => {
  if (type === 'msnq' && isCompletedMSNQ(doc)) {
    return {
      scoreDialogOpen: true,
      scoreDialogContent: <MSNQInfo document={doc} statusDoc={getLatestStatusDoc(documents)} />,
    };
  } else if (type === 'fsmc' && isCompletedFSMC(doc)) {
    return {
      scoreDialogOpen: true,
      scoreDialogContent: <FSMCInfo document={doc} statusDoc={getLatestStatusDoc(documents)} />,
    };
  }
  return {
    scoreDialogOpen: false,
    scoreDialogContent: undefined,
  };
};
